module.exports = __webpack_public_path__ + "img/bg3.7b8781ad.png";